export const mentalHealthAssessments = [
    {
      id: 'iq-test',
      title: 'IQ Test',
      subtitle: 'Test Your Cognitive Abilities',
      icon: '🧩',
      type: 'iq',
      stage: 1,
      difficulty: 'Beginner',
      xpReward: 120,
      description: 'Start your journey by testing your cognitive abilities and problem-solving skills.',
      unlockRequirement: null,
      color: 'from-orange-400 to-orange-600'
    },
    {
      id: 'stress-assessment',
      title: 'Stress Explorer',
      subtitle: 'Discover Your Stress Patterns',
      icon: '🧠',
      type: 'stress',
      stage: 2,
      difficulty: 'Intermediate',
      estimatedTime: '3-5 mins',
      xpReward: 50,
      description: 'Understand how stress affects you and learn management strategies.',
      unlockRequirement: 'iq-test',
      color: 'from-blue-400 to-blue-600'
    },
    {
      id: 'anxiety-screening',
      title: 'Anxiety Navigator',
      subtitle: 'Chart Your Emotional Landscape',
      icon: '🌊',
      type: 'anxiety',
      stage: 3,
      difficulty: 'Intermediate',
      estimatedTime: '5-7 mins',
      xpReward: 75,
      description: 'Dive deeper into understanding anxiety patterns and triggers.',
      unlockRequirement: 'stress-assessment',
      color: 'from-green-400 to-green-600'
    },
    {
      id: 'wellbeing-check',
      title: 'Wellness Master',
      subtitle: 'Complete Your Mental Health Portrait',
      icon: '💚',
      type: 'wellbeing',
      stage: 4,
      difficulty: 'Advanced',
      estimatedTime: '7-10 mins',
      xpReward: 100,
      description: 'Master level assessment for comprehensive mental wellness insights.',
      unlockRequirement: 'anxiety-screening',
      color: 'from-purple-400 to-purple-600'
    }
  ];

export const badges = [
    {
      id: 'first-step',
      title: 'First Step',
      description: 'Completed your first assessment',
      icon: '🏃‍♀️',
      color: 'bg-yellow-500',
      requirement: 1
    },
    {
      id: 'iq-genius',
      title: 'IQ Genius',
      description: 'Completed the Intelligence Quest assessment',
      icon: '🧩',
      color: 'bg-orange-500',
      requirement: 'iq-test'
    },
    {
      id: 'stress-warrior',
      title: 'Stress Warrior',
      description: 'Completed the Stress Explorer assessment',
      icon: '⚔️',
      color: 'bg-blue-500',
      requirement: 'stress-assessment'
    },
    {
      id: 'anxiety-navigator',
      title: 'Anxiety Navigator',
      description: 'Mastered the Anxiety Navigator assessment',
      icon: '🧭',
      color: 'bg-green-500',
      requirement: 'anxiety-screening'
    },
    {
      id: 'wellness-master',
      title: 'Wellness Master',
      description: 'Achieved the highest level of self-awareness',
      icon: '👑',
      color: 'bg-purple-500',
      requirement: 'wellbeing-check'
    },
    {
      id: 'perfectionist',
      title: 'Perfectionist',
      description: 'Scored 90%+ on any assessment',
      icon: '💎',
      color: 'bg-pink-500',
      requirement: 'high-score'
    },
    {
      id: 'consistent',
      title: 'Consistent Explorer',
      description: 'Retaken assessments to track progress',
      icon: '📈',
      color: 'bg-indigo-500',
      requirement: 'retake'
    }
  ];


